/* eslint-disable  jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Fields, reduxForm, reset } from 'redux-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FormGroup, FormControl, ControlLabel, Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';


import {
  ModalListPanel,
  generateValidation,
  registerDatePickerLocale,
} from 'ecs-react-components/dist/index.es';
import { findCcdaExternalSystems } from '../../redux/modules/health-summary/external-systems-mapper';
import { filterHealthSummary, getMostRecentOfficeVisitsForPatient }
from '../../redux/modules/health-summary/health-summary-middleware';
import {
  optionsSelected,
  updateHealthSummaryIdentifier,
} from '../../redux/modules/health-summary/actions/creators';
import { externalSystemSelected } from '../../redux/modules/external-systems/actions/creators';

import { messages } from './CcdaOptionsForm.i18n';
import validations from './CcdaOptionsForm.validations';

import { findVisitIndex } from '../../redux/modules/health-summary/health-summary-mapper';
import CalendarCustomInput from './CalendarCustomInput';

export const fields = ['startDate', 'endDate', 'externalSystemsField', 'recentVisitIndexField', 'radioValueField'];

class CcdaOptionsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDateInvalid: false,
      toDateInvalid: false,
      externalSystemInvalid: false,
      recentVisitIndexInvalid: false,
    };
  }

  componentDidMount() {
    const {
      patientId,
      dispatch,
      language,
    } = this.props;

    registerDatePickerLocale(language);
    dispatch(getMostRecentOfficeVisitsForPatient(patientId, language));
  }

  onSubmit = (formValues) => {
    const {
      dispatch,
      close,
      recentVisits,
      handleReloadHtml,
    } = this.props;

    const {
      externalSystemsField,
      recentVisitIndexField,
      radioValueField,
    } = formValues;

    const startDate = moment(formValues.startDate);
    const endDate = moment(formValues.endDate);

    if (radioValueField === 'visits') {
      if (recentVisitIndexField < 0 || recentVisitIndexField >= recentVisits.length) {
        this.setState({
          recentVisitIndexInvalid: true,
        });
        return;
      }

      dispatch(optionsSelected({
        radioValue: radioValueField,
        selectedVisitIdentifier: recentVisits[recentVisitIndexField].identifier,
      }));

      if (recentVisits && recentVisits.length) {
        dispatch(updateHealthSummaryIdentifier(
          recentVisits[recentVisitIndexField].identifier
        ));

        if (handleReloadHtml) {
          handleReloadHtml();
        }
      }

      close();
      return;
    }
    if (radioValueField === 'daterange') {
      if (!(startDate && startDate.isValid())) {
        this.setState({
          fromDateInvalid: true,
        });
        return;
      }

      if (!(endDate && endDate.isValid())) {
        this.setState({
          toDateInvalid: true,
        });
        return;
      }
    }

    if (!(externalSystemsField)) {
      this.setState({
        externalSystemInvalid: true,
      });
      return;
    }

    let earlyDate = startDate;
    let lateDate = endDate;

    if (startDate.isAfter(endDate)) {
      earlyDate = endDate;
      lateDate = startDate;
    }

    dispatch(optionsSelected({
      startDate: earlyDate.format('l'),
      endDate: lateDate.format('l'),
      radioValue: radioValueField,
      selectedExternalSystem: externalSystemsField,
    }));

    this.filterHealthSummary(formValues);

    if (externalSystemsField) {
      dispatch(externalSystemSelected(true));
    }

    if (handleReloadHtml) {
      handleReloadHtml();
    }

    close();
  }

  onClose = () => {
    this.props.dispatch(reset('ccdaOptionsForm'));
    this.props.close();
  }

  onFromDateChange = (fromDate) => {
    this.props.change('startDate', fromDate);
    this.setState({ fromDateInvalid: false });
  }

  onToDateChange = (toDate) => {
    this.props.change('endDate', toDate);
    this.setState({ toDateInvalid: false });
  }

  onClearStartDateClick = (event) => {
    event.preventDefault();
    this.props.change('startDate', null);
  }

  onClearEndDateClick = (event) => {
    event.preventDefault();
    this.props.change('endDate', null);
  }

  handleRadioChange = (e) => {
    this.props.change('radioValueField', e.currentTarget.value);

    // Clear the recentVisitIndex selection
    if (e.currentTarget.value !== 'visits') {
      this.props.change('recentVisitIndexField', -1);
    }

    this.setState({
      fromDateInvalid: false,
      toDateInvalid: false,
      externalSystemInvalid: false,
      recentVisitIndexInvalid: false,
    });
  };

  handleDateFocus = () => {
    // Clear the recentVisitIndex selection
    this.props.change('radioValueField', 'daterange');
    this.props.change('recentVisitIndexField', -1);
  }

  filterHealthSummary = (formValues) => {
    const {
      patientId,
      dispatch,
      externalSystems: {
        externalSystems,
      },
    } = this.props;

    const {
      externalSystemsField,
    } = formValues;

    const startDate = moment(formValues.startDate);
    const endDate = moment(formValues.endDate);

    const dateFormat = 'YYYY-MM-DD';
    let earlyDate = startDate;
    let lateDate = endDate;
    if (startDate.isAfter(endDate)) {
      earlyDate = endDate;
      lateDate = startDate;
    }

    // externalSystemsField can store either a string or number.
    const ccdaExternalSystem = externalSystems.find(
      (x) => x.ifSystemId.toString() === externalSystemsField.toString());

    dispatch(filterHealthSummary(patientId, {
      ifSystemId: externalSystemsField,
      startDate: earlyDate.format(dateFormat),
      endDate: lateDate.format(dateFormat),
    }, ccdaExternalSystem.patientDisplayName));
  }

  handleDropdownOnChange = (fldOnChange) => (values, dispatch, props) => {
    this.setState({ externalSystemInvalid: false });

    if (fldOnChange) {
      fldOnChange(values, dispatch, props);
    }
  }

  handleListItemClick = (index) => {
    if (index < 0) {
      return;
    }

    this.setState({
      recentVisitIndexInvalid: false,
    });

    this.props.change('recentVisitIndexField', index);
    this.props.change('radioValueField', 'visits');
  };

  renderDropdown = (ccdaExternalSystems, field, externalSystemInvalid) => {
    const getLabel = (f) => f + 'Label';

    /* eslint-disable */
    return (
      <FormGroup controlId={field.name}
        validationState={externalSystemInvalid ? 'error' : ''}
        bsClass="form-group marginlr20"
      >
        <ControlLabel data-qa-item={'label_' + field.name}
          id={getLabel(field.name)}
        >
          <FormattedMessage {...messages.page.form.label.system} />&nbsp;
          { externalSystemInvalid &&
            <span id="externalSystem_required"
              className="label label-danger header invalid-label margin-required"
            >
              <FormattedMessage {...messages.page.form.error.required} />
            </span>}
        </ControlLabel>
        <FormControl componentClass="select"
          value={field.value || ''}
          onChange={this.handleDropdownOnChange(field.onChange)}
          onFocus={this.handleDateFocus}
          data-qa-item={field.name}
          role="button"
          aria-invalid={externalSystemInvalid}
          aria-describedby="selectMessage"
        >
          <option data-qa-item="options_empty"></option>
          { ccdaExternalSystems.map(
            (system) => (
              <option key={'key_' + system.ifSystemId}
                value={system.ifSystemId}
                data-qa-item={'options_' + system.ifSystemId}
              >
                {system.patientDisplayName}
              </option>))}
        </FormControl>
        <span id="selectMessage" className="sr-only" >
          <FormattedMessage {...messages.page.form.label.systemHint} />
        </span>
      </FormGroup>
    );
  }

  renderDateRange = (fieldsMeta) => {
    const { language, intl } = this.props;

    const {
      startDate,
      endDate,
      fromDateInvalid,
      toDateInvalid,
    } = fieldsMeta;

    return (
      <div className="form-inline marginlr20">
        <span className={fromDateInvalid ? 'has-error' : ''}>
          <DatePicker id={startDate.input.name}
            name={startDate.input.name}
            dateFormat="MMM d, yyyy"
            className="form-control"
            locale={language}
            selected={startDate.input.value}
            onChange={this.onFromDateChange}
            onFocus={this.handleDateFocus}
            showMonthDropdown
            showYearDropdown
            dropdownMode="scroll"
            customInput={
              <CalendarCustomInput
                aria-label={intl.formatMessage(messages.page.form.label.clearStartDateHint)}
                id={'input_' + startDate.input.name}
              />
            }
          />
        </span>
        <span className="date-range-to"><FormattedMessage {...messages.page.tolabel} /></span>
        <span className={toDateInvalid ? 'has-error' : ''}>
          <DatePicker id={endDate.input.name}
            name={endDate.input.name}
            dateFormat="MMM d, yyyy"
            className="form-control"
            locale={language}
            selected={endDate.input.value}
            onChange={this.onToDateChange}
            onFocus={this.handleDateFocus}
            showMonthDropdown
            showYearDropdown
            dropdownMode="scroll"
            customInput={
              <CalendarCustomInput
                aria-label={intl.formatMessage(messages.page.form.label.clearEndDateHint)}
                id={'input_' + endDate.input.name}
              />
            }
          />
        </span>
        <label id="startDate_hint" className="sr-only" htmlFor={startDate.input.name}>
          <FormattedMessage {...messages.page.form.label.startDateHint} />&nbsp;
          { (fromDateInvalid) &&
            <FormattedMessage {...messages.page.form.error.required} />}
        </label>
        <label id="endDate_hint" className="sr-only" htmlFor={endDate.input.name}>
          <FormattedMessage {...messages.page.form.label.endDateHint} />&nbsp;
          { (toDateInvalid) &&
            <FormattedMessage {...messages.page.form.error.required} />}
        </label>
      </div>
    );
  }

  renderVisitItemHeading = (item) => () => (
    <span>
      <div className="message-date-box">
        <span className="message-date">{ item.encounterDate.datePart }</span>
      </div>
      <span className="primary-text">{item.visitType}</span>
    </span>
  );

  renderVisitItemSubText = (item) => () => (
    <span className="secondary-text bold">
      {item.provider}
    </span>
  );

  renderRecentVisitsContainer = (recentVisits, recentVisitIndexField) => {
    if (!(recentVisits && recentVisits.length)) {
      return (<div className="marginlr20">
        <FormattedMessage {...messages.page.form.label.noVisits} />
              </div>);
    }

    const renderedItems = recentVisits.map((item, idx) => ({
      heading: this.renderVisitItemHeading(item),
      subText: this.renderVisitItemSubText(item),
      itemId: idx,
    }));

    return (
      <div className="row">
        <div className="col-xs-12">
          <ModalListPanel
            items={renderedItems}
            handleListItemClick={this.handleListItemClick}
            qaTag="recentVisitsContainer"
            selectedIndex={recentVisitIndexField.value}
          />
        </div>
      </div>
    );
  }

  renderFields = (fieldsMeta) => {
    const {
      externalSystemsField,
      recentVisitIndexField,
      radioValueField,
      recentVisits,
      externalSystems,
      fromDateInvalid,
      toDateInvalid,
      recentVisitIndexInvalid,
      externalSystemInvalid,
    } = fieldsMeta;

    let ccdaExternalSystems = null;
    if (externalSystems && externalSystems.length > 0) {
      ccdaExternalSystems = findCcdaExternalSystems(externalSystems);
      ccdaExternalSystems.sort(
        (a, b) => {
          const nameA = a.patientDisplayName.toUpperCase();
          const nameB = b.patientDisplayName.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          return nameA > nameB ? 1 : 0;
        });
    }

    return (
      <FormGroup>
        <div className="radio">
          <label htmlFor="optionGroupDates">
            <input
              type="radio"
              name="optionGroup"
              id="optionGroupDates"
              value="daterange"
              onChange={ this.handleRadioChange }
              checked={radioValueField.input.value === 'daterange'}
            />
            <FormattedMessage {...messages.page.form.label.daterange} />&nbsp;
            { (fromDateInvalid || toDateInvalid) &&
              <span className="form-validation-error" aria-describedby="dates_required" >
                <span id="dates_required">
                  <FormattedMessage {...messages.page.form.error.dateRequired} />
                </span>
              </span>}
          </label>
        </div>
        { this.renderDateRange(fieldsMeta) }
        { ccdaExternalSystems && ccdaExternalSystems.length > 1 ?
          this.renderDropdown(ccdaExternalSystems, externalSystemsField.input, externalSystemInvalid) :
          null}
        <div className="spacer small"></div>
        <hr />
        <div className="radio">
          <label htmlFor="optionGroupVisits">
            <input
              type="radio"
              name="optionGroup"
              id="optionGroupVisits"
              value="visits"
              onChange={ this.handleRadioChange }
              disabled={!(recentVisits && recentVisits.length)}
              checked={radioValueField.input.value === 'visits'}
            />
            <FormattedMessage {...messages.page.form.label.visits} />&nbsp;
            { (recentVisitIndexInvalid) &&
              <span className="form-validation-error" role="alert">
                <FormattedMessage {...messages.page.form.error.visitPickRequired} />
              </span>}
          </label>
        </div>
        { this.renderRecentVisitsContainer(recentVisits, recentVisitIndexField.input) }
      </FormGroup>
    );
  }

  render = () => {
    const { handleSubmit,
      recentVisits,
      externalSystems: {
        externalSystems,
      },
      showModal,
    } = this.props;

    const {
      fromDateInvalid,
      toDateInvalid,
      externalSystemInvalid,
      recentVisitIndexInvalid,
    } = this.state;

    return (
      <Modal show={ showModal }
        onHide={ this.onClose }
        backdrop="static"
        aria-labelledby="modalTitle"
      >
        <Modal.Header closeButton>
          <Modal.Title data-qa-item="modal-title">
            <div id="modalTitle" tabIndex="0">
              <FormattedMessage {...messages.page.title} />
            </div>
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Modal.Body>
            <p data-qa-item="PrimaryExplanation" tabIndex="0">
              <FormattedMessage {...messages.page.instruction} />
            </p>
            <Fields names={fields}
              component={this.renderFields}
              recentVisits={recentVisits}
              externalSystems={externalSystems}
              fromDateInvalid={fromDateInvalid}
              toDateInvalid={toDateInvalid}
              externalSystemInvalid={externalSystemInvalid}
              recentVisitIndexInvalid={recentVisitIndexInvalid}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              className="btn btn-primary"
              data-qa-item="SubmitButton"
            >
              <FormattedMessage {...messages.page.form.button.update} />
            </Button>
            <Button type="button" className="btn btn-default" onClick={ this.onClose } data-qa-item="CancelButton">
              <FormattedMessage {...messages.page.form.button.cancel} />
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

CcdaOptionsForm.propTypes = {
  language: PropTypes.string,
  fields: PropTypes.array,
  form: PropTypes.string,
  dispatch: PropTypes.func,
  showModal: PropTypes.bool,
  close: PropTypes.func,
  externalSystems: PropTypes.object,
  healthSummaryOptions: PropTypes.object,
  patientId: PropTypes.number,
  handleSubmit: PropTypes.func,
  recentVisits: PropTypes.array,
  intl: PropTypes.object,
  change: PropTypes.func,
  handleReloadHtml: PropTypes.func,
};

const formConfig = {
  form: 'ccdaOptionsForm',
  fields,
  enableReinitialize: true,
  ...generateValidation(validations),
};

const mapStateToProps = (state) => {
  const ccdaExternalSystems = findCcdaExternalSystems(state.externalSystems.externalSystems);
  const externalSystemId = ccdaExternalSystems && ccdaExternalSystems.length === 1 ?
    ccdaExternalSystems[0].ifSystemId :
    state.healthSummary.options.selectedExternalSystem;

  return {
    externalSystems: state.externalSystems,
    healthSummaryOptions: state.healthSummary.options,
    recentVisits: state.healthSummary.recentVisits,
    patientId: state.profile.patient.patientId,
    initialValues: {
      startDate: moment(state.healthSummary.options.startDate).toDate(),
      endDate: moment(state.healthSummary.options.endDate).toDate(),
      radioValueField: state.healthSummary.options.radioValue,
      externalSystemsField: externalSystemId || null,
      recentVisitIndexField: findVisitIndex(state.healthSummary.recentVisits,
        state.healthSummary.options.selectedVisitIdentifier),
    },
  };
};

export default (connect(mapStateToProps)(reduxForm(formConfig)(injectIntl(CcdaOptionsForm))));
